import React, { useEffect, useState } from 'react';
import { MAINTENANCE_MODE, BYPASS_MAINTENANCE_COOKIE_NAME } from 'constants';
import MaintenanceImage from 'images/maintenance.svg';
import EmptyState from 'components/ui/empty_state';
import { Panel, Section } from 'components/ui';
import { Row, Col } from 'components/ui/grid';
import InsurgateLogo from 'images/insurgate_dark.svg';
import { getConfig } from 'requests/config';
import sessionStore from 'services/session_store';

const MaintenanceMode = ({ children }) => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('bypass_maintenance')) {
    sessionStore.set(BYPASS_MAINTENANCE_COOKIE_NAME, '1');
  }
  let interval = null;
  const [isMaintenance, setIsMaintenance] = useState(MAINTENANCE_MODE);
  const pollForMaintenance = () => {
    getConfig().then(() => {
      setIsMaintenance(false);
      clearInterval(interval);
    });
  };
  const setMaintenance = () => {
    setIsMaintenance(true);
    if (interval) {
      return;
    }
    interval = setInterval(pollForMaintenance, 2000);
  };
  useEffect(() => {
    window.setMaintenance = setMaintenance;
  }, []);
  if (isMaintenance) {
    return (
      <Section fluid className="py-0">
        <Row className="min-vh-100 flex-center g-0">
          <Col lg={8} className="col-xxl-5 py-3">
            <p className="text-center">
              <img
                src={InsurgateLogo}
                alt="insurgate"
                style={{ width: '250px' }}
              />
            </p>
            <Panel>
              <EmptyState
                title="Maintenance"
                image={MaintenanceImage}
                subTitle="Insurgate is currently in maintenance. Please come back later"
              />
            </Panel>
          </Col>
        </Row>
      </Section>
    );
  }
  return children;
};

export default MaintenanceMode;
